module.exports = __webpack_public_path__ + "img/file-thumbnail.a1e31c48.png";